<template>
    <Modal @cancel="cancel">
        <ModalCard
            @cancel="cancel"
            :headerTitle="$t('modale.my.account.title')"
            :withoutBotNav="true"
            :active-validate="false"
            id="loadingdiv"
        >
            <content-loader v-if="isLoading" :width="width" height="300">
                <rect x="2" y="10" rx="4" ry="4" :width="width/3" height="20" />
                <rect x="2" y="35" rx="4" ry="4" :width="width" height="116" />
                <rect x="2" y="170" rx="4" ry="4" :width="width/3" height="20" />
                <rect x="2" y="195" rx="4" ry="4" :width="width" height="76" />
            </content-loader>
            <template v-else>
                <div class="text-container" v-if="this.tableData1.length !== 0">
                    <h3 class="title">
                        {{ $t('modale.my.account.personal.informations') }}
                        <ReglePastille cle="monCompte.champsEnLectureSeule" />
                    </h3>
                </div>
                <DataList :data="this.tableData1"/>

                <div class="text-container second-container" v-if="this.tableData2.length !== 0">
                    <h3 class="title">{{ $t('modale.my.account.contact.title') }}</h3>
                </div>
                <DataList class="last" :data="this.tableData2"/>
                <div class="editable-row">
                    <span class="leftSide">
                        {{$t('modale.my.account.contact.password.label')}}
                        <ReglePastille cle="monCompte.motDePasseRegles" />
                    </span>
                    <EditableInput
                        :model-value="mdp"
                        :is-saving="isPhoneSaving"
                        :mdp='true'
                        @save="sauvegarderMdp"
                        class="rightSide"/>
                </div>
                <div class="editable-row">
                    <span class="leftSide">{{$t('modale.my.account.contact.phone')}}</span>
                    <EditableInput class="rightSide" :model-value="this.profil.telephoneFixe" @save="savePhone" :is-saving="isPhoneSaving"/>
                </div>
                <div class="editable-row">
                    <span class="last leftSide">{{$t('modale.my.account.contact.mobile')}}</span>
                    <EditableInput class="rightSide" :model-value="this.profil.telephonePortable" @save="saveMobilePhone" :is-saving="isMobilePhoneSaving"/>
                </div>
                <div class="suppression-container">
                    <ReglePastille cle="monCompte.suppressionCompte" />
                    <ButtonBlue
                        className="redBtn btn-suppression"
                        :text="isDeleteAccountRequested ? $t('modale.my.account.delete.requested') : $t('modale.my.account.delete.request')"
                        :onClick="openDeleteConfirm"
                        :disabled="isDeleteAccountRequested"

                    />
                </div>
            </template>
        </ModalCard>
    </Modal>
    <Modal v-if="showDeleteConfirm" @cancel="closeDeleteConfirm">
        <ModalCardYesNo
            :headerTitle="$t('modale.my.account.delete.confirm.title')"
            :active-validate="true"
            @yes="confirmDeleteAccount"
            @no="closeDeleteConfirm"
            @cancel="closeDeleteConfirm"
        >
            <p class="confirm-text">
                {{ $t('modale.my.account.delete.confirm.message') }}
            </p>
        </ModalCardYesNo>
    </Modal>
    <SuccessModal
        v-if="showDeleteSuccess"
        :title="''"
        :subtitle="$t('modale.my.account.delete.success.message')"
        @cancel="closeDeleteSuccess"
    />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Modal from '@/components/ui-components/Modal.vue';
import ModalCard from '@/components/ui-components/ModalCard.vue';
import { ContentLoader } from 'vue-content-loader';
import { store } from '@/plugins/store';
import { MON_COMPTE } from '@/modules/MonCompte/store/mutation-types';
import DataList from '@/components/ui-components/DataList.vue';
import { MonCompteModuleAction } from '@/modules/MonCompte/store/actions-types';
import EditableInput from '@/components/ui-components/EditableInput.vue';
import { ProfilDTO } from '@/modules/Account/store/state';
import ButtonBlue from '@/components/ui-components/Button.vue';
import ModalCardYesNo from '@/components/ui-components/ModalCardYesNo.vue';
import SuccessModal from '@/components/ui-components/SuccessModal.vue';
import ReglePastille from '@/components/regles/ReglePastille.vue';

export default defineComponent({
    name: 'MonCompteModale',
    components: {
        SuccessModal,
        ModalCardYesNo,
        ButtonBlue,
        EditableInput,
        ContentLoader,
        DataList,
        Modal,
        ModalCard,
        ReglePastille,
    },
    async beforeMount() {
        const tables = await store.dispatch(`monCompteState/${MonCompteModuleAction.LOAD_INFORMATIONS}`);
        this.tableData1 = tables.tableData;
        this.tableData2 = tables.tableData2;
        await store.dispatch(`monCompteState/${MonCompteModuleAction.LOAD_DELETE_ACCOUNT_REQUESTED}`);

    },
    mounted() {
        const loadingElement: typeof HTMLElement | any = document.getElementById('loadingdiv');
        this.width = loadingElement.offsetWidth-48;
    },
    data(){
        return {
            width: 0,
            tableData1: [],
            tableData2: [],
            mdp: this.$t('modale.my.account.contact.password.masque'),
            showDeleteConfirm: false,
            showDeleteSuccess: false

        };
    },
    methods: {
        cancel() {
            store.commit(`monCompteState/${MON_COMPTE.SET_MODAL}`, false);
        },
        saveMobilePhone(tel: string){
            store.dispatch(`monCompteState/${MonCompteModuleAction.SAVE_MOBILE_PHONE}`, tel);
        },
        savePhone(tel: string){
            store.dispatch(`monCompteState/${MonCompteModuleAction.SAVE_PHONE}`, tel);
        },
        sauvegarderMdp(mdp: string) {
            store.dispatch(`monCompteState/${MonCompteModuleAction.SAUVEGARDER_MDP}`, mdp);
        },
        openDeleteConfirm() {
            this.showDeleteConfirm = true;
        },
        closeDeleteConfirm() {
            this.showDeleteConfirm = false;
        },
        async confirmDeleteAccount() {
            this.showDeleteConfirm = false;
            await store.dispatch(`monCompteState/${MonCompteModuleAction.DEMANDER_SUPPRESSION_COMPTE}`);
            this.showDeleteSuccess = true;
        },
        closeDeleteSuccess() {
            this.showDeleteSuccess = false;
            this.cancel();
        }
    },
    computed: {
        isLoading(): boolean {
            return store.state.monCompteState.isLoading;
        },
        profil(): ProfilDTO {
            return store.state.monCompteState.profil;
        },
        isPhoneSaving(){
            return store.state.monCompteState.isPhoneSaving;
        },
        isMobilePhoneSaving(){
            return store.state.monCompteState.isMobilePhoneSaving;
        },
        isDeleteAccountRequested(): boolean {
            return store.state.monCompteState.isDeleteAccountRequested;
        }
    }
});
</script>

<style scoped>
:deep(.card-container){
    width: 45vw;
}
:deep(.dataListContainer){
    margin-top: 4px;
    margin-bottom: 0;
    border: 0;
}
.text-container {
    flex: 1;
    margin-left: 2px;
    padding-bottom: 2px;
    font-size: var(--font-size-low-medium);
    font-weight: var(--font-weight-300);
}
.second-container {
    margin-top: 6px;
    padding-top: 10px;
}
.title {
    font-family: 'Raleway Semi Bold', sans-serif;
    font-size: var(--font-size-medium);
    margin: 0 0 3px 0;
    color: var(--color-principal);
}
:deep(.leftSide) {
    width: 40%;
}
:deep(.rightSide) {
    padding: 4px 10px;
}
.last :deep(.row:last-child .leftSide){
    border-bottom-left-radius: 0;
}
.last {
    border-bottom-left-radius: 6px;
}
:deep(.row:last-child .rightSide:last-child){
    padding-bottom: 0;
}
.leftSide {
    display: flex;
    align-items: center;
    padding: 4px 20px;
    min-height: 30px;
    background-color: var(--color-principal-transparent);
    text-overflow: ellipsis;
    width: 40%;
}
.rightSide {
    display: flex;
    min-height: 30px;
    padding: 4px 10px;
    width: 100%;
}
.editable-row {
    display: flex;
}
.suppression-container {
    margin-top: 16px;
    display: flex;
    justify-content: flex-end;
}

.btn-suppression {
    height: 32px;
    font-size: var(--font-size-very-small);
    width: 220px;
}


</style>
